/**
 * SIL-2203: the site label printer address, `ip:9100`.
 *
 * One rule in three places, kept identical: the database (bench_label_printer_addr_ok, migration 1176, the CHECK on
 * bench_site.label_printer_addr), this validator (friendly API errors and the agent contract), and the bench agent's
 * printer.rs (the boundary on the device). An RFC1918 IPv4 literal on port 9100, nothing else: no hostname (so nothing
 * can resolve outside), no IPv6, no leading zeros, octets <= 255, last octet 1..254, at most 21 characters, nothing
 * around it.
 */
export const LABEL_PRINTER_PORT = 9100;

const OCTET = '(?:25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])';
const LAST_OCTET = '(?:25[0-4]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[1-9])';
const LABEL_PRINTER_ADDR_RE = new RegExp(`^(?:${OCTET}\\.){3}${LAST_OCTET}:${LABEL_PRINTER_PORT}$`);

/** True when `value` is an acceptable label printer address. Anything that is not a string is false. */
export function isValidLabelPrinterAddr(value: unknown): value is string {
  if (typeof value !== 'string' || value.length > 21 || !LABEL_PRINTER_ADDR_RE.test(value)) return false;
  const [a, b] = value.split('.').map(Number) as [number, number];
  return a === 10 || (a === 172 && b >= 16 && b <= 31) || (a === 192 && b === 168);
}
